import { css, cx, keyframes } from "@emotion/css";
import { borderRadius, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ErrorPanel, type ErrorInfo } from "./ErrorPanel";
interface Level1PageLoadingProps {
    errors?: ErrorInfo[];
    isFullWidth?: boolean;
}
export function Level1PageLoading({ errors, isFullWidth }: Level1PageLoadingProps) {
    const isLargerThanIpad = useMediaQuery({ query: `(min-width: 811px)` });
    if (errors && errors.length > 0) {
        return (<>
                {errors?.map((error, index) => (<ErrorPanel key={index} error={error}/>))}
            </>);
    }
    return (<div className={cx(containerStyles, { [containerHasPaddingMobile]: !isLargerThanIpad, [containerMaxWidthStyles]: !isFullWidth })}>
            <header role="progressbar" className={headerContainerStyles}>
                <div className={breadcrumbContainerStyles}>
                    <div className={cx(breadcrumbPlaceholderStyles)}/>
                </div>
                <div className={cx(headerContentStyles, { [headerContentMobileStyles]: !isLargerThanIpad })}>
                    <div className={cx(skeletonStyles, titlePlaceholderStyles)}/>
                    <div className={cx(skeletonStyles, pageActionsPlaceholderStyles)}/>
                </div>
            </header>
        </div>);
}
const pulseKeyframes = keyframes({
    "0%": { backgroundColor: themeTokens.color.background.tertiary },
    "50%": { backgroundColor: "white" },
    "100%": { backgroundColor: themeTokens.color.background.tertiary },
});
const skeletonStyles = css({
    // This animation has a 0.5s delay sa that a quick chain of redirects doesn't show a constantly resetting animation
    animation: `${pulseKeyframes} 2s linear 0.5s infinite`,
    borderRadius: borderRadius.small,
});
const containerStyles = css({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
    padding: space[32],
});
const containerHasPaddingMobile = css({
    padding: space[16],
});
const containerMaxWidthStyles = css({
    maxWidth: 1280,
});
const headerContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    paddingBottom: space[32],
    gap: "unset",
});
const headerContentStyles = css({
    display: "flex",
    justifyContent: "space-between",
    gap: space[48],
    // This header content should have a min height set to the height of the buttons.
    // This prevents the header from changing size to accommodate buttons that are added or removed.
    minHeight: "2.25rem",
});
const headerContentMobileStyles = css({
    flexDirection: "column",
    gap: space[24],
    alignItems: "unset",
});
const breadcrumbContainerStyles = css({
    display: "flex",
    alignItems: "flex-start",
    height: "1.75rem",
});
const breadcrumbPlaceholderStyles = css({
    height: "1.25rem",
    width: "3.25rem",
});
const titlePlaceholderStyles = css({
    height: "2.25rem",
    width: "14.25rem",
});
const pageActionsPlaceholderStyles = css({
    height: "2.25rem",
    width: "8rem",
});
